import { mdiKey } from '@mdi/js'

export default {
  aliases: {
    apiKeys: mdiKey,
  },
}
